import { queryOptions } from '@tanstack/react-query';

import { fetchShopCategory } from '@/utils/shopCategoryApi';

export const SHOP_CATEGORY_QUERY_KEY = 'shopCategory';

const THIRTY_SECONDS_MS = 30 * 1000;

export const shopCategoryQueryOptions = (categoryKey: string) =>
    queryOptions({
        queryKey: [SHOP_CATEGORY_QUERY_KEY, categoryKey],
        queryFn: () => fetchShopCategory(categoryKey),
        enabled: Boolean(categoryKey),
        retry: false,
        staleTime: THIRTY_SECONDS_MS,
    });
